// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"be5ddf52","703":"33e22cf6","787":"b6ab8638"}[chunkId] + ".chunk.js";
};